import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { storefront } from '../lib/supabase';
import { pickLang } from '../lib/format';
import ProductCard from '../components/ProductCard';
import ComboCard from '../components/ComboCard';

function SectionRow({ title, filterKey, items, renderItem }) {
  const { t } = useLang();
  if (!items?.length) return null;
  return (
    <section className="section">
      <div className="row spread" style={{ marginBottom: 14 }}>
        <h2 style={{ margin: 0 }}>{title}</h2>
        <Link to={`/products?filter=${filterKey}`} className="muted">{t('home.viewAll')} →</Link>
      </div>
      <div className="grid grid-4">{items.slice(0, 4).map(renderItem)}</div>
    </section>
  );
}

export default function Home() {
  const { lang, t } = useLang();
  const [data, setData] = useState({ products: [], combos: [], hero: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    Promise.all([storefront.products(), storefront.combos(), storefront.content()])
      .then(([p, c, ct]) => {
        if (p.error || c.error) throw p.error || c.error;
        setData({
          products: p.data || [],
          combos: c.data || [],
          hero: (ct.data || []).find((x) => x.key === 'hero'),
        });
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">{t('misc.loading')}</div>;
  if (error) return <div className="empty">{t('misc.error')}</div>;

  const { products, combos, hero } = data;
  const onSale = products.filter((p) => Number(p.sale_price) && Number(p.sale_price) < Number(p.price));

  return (
    <div className="container">
      <div className="hero">
        <div className="emoji">🌊🐚🎁</div>
        <h1>{hero ? pickLang(hero, 'title', lang) : 'Life in Nha Trang'}</h1>
        <p>{hero ? pickLang(hero, 'body', lang) : ''}</p>
        <Link to="/products" className="btn btn-primary">{t('home.cta')}</Link>
      </div>

      <SectionRow title={`🔥 ${t('home.hot')}`} filterKey="hot" items={products.filter((p) => p.is_hot_seasonal)} renderItem={(p) => <ProductCard key={p.id} product={p} />} />
      <SectionRow title={`⭐ ${t('home.best')}`} filterKey="best" items={products.filter((p) => p.is_best_seller)} renderItem={(p) => <ProductCard key={p.id} product={p} />} />
      <SectionRow title={`⏳ ${t('home.limited')}`} filterKey="limited" items={products.filter((p) => p.is_limited)} renderItem={(p) => <ProductCard key={p.id} product={p} />} />
      <SectionRow title={`🏷️ ${t('home.sale')}`} filterKey="sale" items={onSale} renderItem={(p) => <ProductCard key={p.id} product={p} />} />
      <SectionRow title={`🎁 ${t('home.combo')}`} filterKey="combo" items={combos} renderItem={(c) => <ComboCard key={c.id} combo={c} />} />
      <SectionRow title={`💛 ${t('home.favorite')}`} filterKey="favorite" items={products.filter((p) => p.is_favorite)} renderItem={(p) => <ProductCard key={p.id} product={p} />} />
    </div>
  );
}
